import axios from "@/axios";

export async function studentLogin(data) {
  const res = await axios.post("/api/student/login", data);
  return res.data.student;
}

export async function fetchStudentMe() {
  const res = await axios.get("/api/student/me");
  return res.data;
}

export async function studentLogout() {
  await axios.post("/api/student/logout");
}


// 🟢 تفعيل كورس باستخدام كود
export async function activateCourse(courseId, code) {
  const res = await axios.post("/api/public/courses/activate", {
    course_id: courseId,
    code: code,
  });

  return res.data;
}

// 🟢 التحقق هل الطالب مشترك في الكورس
export async function checkCourseEnrollment(courseId) {
  const res = await axios.get(
    `/api/student/public/courses/${courseId}/check-enrollment`
  );
  return res.data.enrolled;
}

// 🟢 جلب الكورسات اللي الطالب مشترك فيها
export async function fetchMyCourses() {
  const res = await axios.get("/api/student/my-courses");
  return res.data.courses;
}

// 🟢 إرسال تقييم الكورس
export async function submitCourseReview(courseId, rating, comment) {
  const res = await axios.post(
    `/api/student/courses/${courseId}/review`,
    {
      rating,
      comment,
    }
  );
  return res.data;
}

// 🟢 جلب جميع تقييمات وتعليقات الكورس (Public)
export async function fetchCourseReviews(courseId) {
  const res = await axios.get(
    `/api/public/courses/${courseId}/reviews`
  );

  return res.data.reviews;
}


// 🟢 تسجيل طالب جديد
export async function registerStudent(data) {
  const res = await axios.post(
    "/api/public/student/register",
    data
  );

  return res.data;
}

